import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	iconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'issue-field-atlas-project-common.private-project-popup.title',
		defaultMessage: 'This is a private project',
		description: 'Title of the private project popup, indicating that this project is private',
	},
	description: {
		id: 'issue-field-atlas-project-common.private-project-popup.description',
		defaultMessage:
			'Only contributors or people the project is shared with can view this private project. Contact your admin to see if you can get access.',
		description:
			'Description of the private project popup, indicating that this project is private',
	},
	iconLabel: {
		id: 'issue-field-atlas-project-common.private-project-popup.icon-label',
		defaultMessage: 'Private project',
		description: 'Accessible label for lock icon',
	},
});
export default messages;
